import { FC } from 'react'

import { selectedKey, FilterTypeName } from 'constants/search-data/search-data'
import { IConfig, IInitParams } from 'constants/types/search.types'
import { IAnyObj } from 'constants/types/common.types'

import styles from './filter-active.module.scss'

interface IFilterActive {
  config: IConfig
  parameters: IInitParams
  handleValue: (value: string) => (value: any) => void
  handleReset: () => void
}

interface IActiveParam {
  label: string
  value: number | string
  key: keyof typeof selectedKey
}

const FilterActive: FC<IFilterActive> = ({
  config,
  parameters,
  handleValue,
  handleReset,
}: IFilterActive) => {
  const selectedParameters = config.main.reduce(
    (acc, item: IAnyObj) =>
      item.inputType === FilterTypeName.SELECT ? acc.concat(parameters[item.key]) : acc,
    []
  )

  const removeValue = (key: string, values: any) => (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.currentTarget?.dataset) {
      const selectedValue = e.currentTarget.dataset.value
      const filteredValues = values.filter(
        ({ value, label }: { value: string | number, label: string }) =>
          value + label !== selectedValue
      )
      handleValue(key)(filteredValues)
    }
  }

  return (
    <div className={styles.selected}>
      {selectedParameters.map(
        (param: IActiveParam) =>
          param?.value && (
            <div
              key={param.value + param.label}
              data-value={param.value + param.label}
              onClick={removeValue(param.key, parameters[param.key])}
              className={styles.valueBox}
            >
              <div className={styles.valueText}>
                <div className={styles.valueType}>{selectedKey[param.key]}</div>
                <div className={styles.valueTitle}>{param.label}</div>
              </div>
              <div className={styles.valueCloseWrapper}>
                <div className={styles.valueClose} />
              </div>
            </div>
          )
      )}
      {selectedParameters.length ? (
        <button className={styles.valueReset} onClick={handleReset}>
          Сбросить все
        </button>
      ) : null}
    </div>
  )
}

export default FilterActive
